<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "dashboard",
};
</script>

<style lang="scss">
@import "../../styles/pages/_dashboard.scss";
</style>
